import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import doc                       from '@widesk-core/decorators/doc';
import model                     from '@widesk-core/decorators/model';

// Ecrit manuellement
@model.cacheDuration()
@model.urnResource('participation_status')
@doc.path('/participation_statuses/{?id}')
export default class ParticipationStatusModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Website_ParticipationStatusReference;

	get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'green';
			case 'DISABLED':
				return 'red';
		}
	}
}
